<section id="dynamic-category-header-2345674" class="dynamic-header-background editable">
    <div class="header-layout-4">
        <!-- 🔍 Search Drop Down -->
        @if (isSearchOverlay && headerData.searchIcon.isVisibleOnDesktop) {
        <div class="search-drop-down-container" (click)="toggleSearchDropDown()">
            <div class="search-drop-down dynamic-header-background" (click)="$event.stopPropagation()">
                <h5 class="dynamic-header-text-color">Start your amazing search :</h5>

                <button class="close-btn" (click)="toggleSearchDropDown()">
                    <img src="https://assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/close-line-icon.png" />
                </button>

                <base-search-bar [selectedDeviceType]="deviceType()" [headerData]="headerData" [searchInputControl]="searchInputControl" [isFocused]="isSearchOverlay" (searchProduct$)="searchProduct($event)" (searchIconClick$)="searchIconClick()" />
            </div>
        </div>
        }

        <!-- 🍔 Logo + Hamburger -->
        <div class="logo-hamburger-wrapper">
            @if (isMobile() && headerData.menuListVisibleOnMobile) {
            <img class="hamburger-btn" [src]="headerData.hamburgerMenuIcon" (click)="toggleHamburgerMenu()" />
            }

            <!-- Mobile Logo -->
            @if (headerData.logo.isVisibleOnMobile && isMobile()) {
            <a [routerLink]="['/']" class="logo">
                <img class="static-header-logo" [src]="headerData.logo.logoSrc" />
            </a>
            } @else {
            <!-- Desktop Logo -->
            @if (headerData.logo.isVisibleOnDesktop && isDesktop()) {
            <a [routerLink]="['/']" class="logo">
                <img class="static-header-logo" [src]="headerData.logo.logoSrc" />
            </a>
            }
            }
        </div>

        <!-- 🧭 Desktop Navigation -->
        @if (headerData.menuListVisibleOnDesktop) {
        <nav #changeHeaderElement class="navigation-wrapper mega-menu-category">
            <ul class="navigation-list static-nav dynamic-menu-alignment">
                <!-- Static Menu -->
                @for (staticMenu of headerData.menuItems; track staticMenu.id) {
                @if (staticMenu.text !== 'Category Header') {
                <li class="editable static-menu">
                    <a [id]="staticMenu.id" [target]="staticMenu.target" [ngClass]="{
                    'hover-color-active': showActiveColor && currentMenuId === staticMenu.id,
                    'hover-color-inactive': !showActiveColor && currentMenuId === staticMenu.id,
                  }" class="static-header dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu" [attr.data-click_action_value]="staticMenu['data-click_action_value']" [attr.data-click_action_choice]="staticMenu['data-click_action_choice']">
                        {{ staticMenu.text }}
                    </a>

                    <!-- Sub Menu -->
                    @if (staticMenu.subMenu?.length) {
                    <div class="submenu-container dynamic-sub-menu-background hide-sub-menu-header" (mouseenter)="showActiveColor = true; currentMenuId = staticMenu.id" (mouseleave)="removeHoverStyle()">
                        @for (subMenu of staticMenu.subMenu; track subMenu.id) {
                        <ul class="submenu">
                            <li>
                                <a [id]="subMenu.id" [target]="subMenu.target" (click)="onLinkClick()" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu" [attr.data-click_action_value]="subMenu['data-click_action_value']" [attr.data-click_action_choice]="subMenu['data-click_action_choice']">
                                    {{ subMenu.text }}
                                </a>
                            </li>

                            @if (subMenu.subMenu?.length) {
                            @for (subSubMenu of subMenu.subMenu; track subSubMenu.id) {
                            <li>
                                <a [id]="subSubMenu.id" [target]="subSubMenu.target" (click)="onLinkClick()" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu" [attr.data-click_action_value]="subSubMenu['data-click_action_value']" [attr.data-click_action_choice]="subSubMenu['data-click_action_choice']">
                                    {{ subSubMenu.text }}
                                </a>
                            </li>
                            }
                            }
                        </ul>
                        }
                    </div>
                    }
                </li>
                }
                }

                <!-- Dynamic Category Header -->
                <div class="dynamic-header" #dynamicCategoryHeader>
                    <!-- Inline Layout -->
                    @if (dynamicHeaderInline() && layoutType() === 'inlineLayout1') {
                    @for (parentCategory of category; track parentCategory.id) {
                    <li>
                        <a [routerLink]="'category/' + parentCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: parentCategory.url_path }" (click)="onLinkClick()" [ngClass]="{
                      'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                      'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                    }" class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color hoverMenu">
                            {{ parentCategory.name }}
                        </a>

                        @if (parentCategory.sub_categories.length) {
                        <div class="submenu-container hide-sub-menu-header dynamic-sub-menu-background" (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()">
                            @for (childCategory of parentCategory.sub_categories; track childCategory.id) {
                            <ul class="submenu">
                                <li>
                                    <a [routerLink]="'category/' + childCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: childCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                        {{ childCategory.name }}
                                    </a>
                                </li>

                                @if (childCategory.sub_categories.length) {
                                @for (subCategory of childCategory.sub_categories; track subCategory.id) {
                                <li>
                                    <a [routerLink]="'category/' + subCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: subCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                        {{ subCategory.name }}
                                    </a>
                                </li>
                                }
                                }
                            </ul>
                            }
                        </div>
                        }
                    </li>
                    }
                    }

                    <!-- Hover Layout -->
                    @if (dynamicHeaderHover() && layoutType() === 'hoverLayout1') {
                    <li>
                        <a (click)="onLinkClick()" class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu">
                            {{ headerData.categoryMenuName }}
                        </a>

                        @if (category.length) {
                        <div class="submenu-container hide-sub-menu-header dynamic-sub-menu-background">
                            @for (parentCategory of category; track parentCategory.id) {
                            <ul class="submenu">
                                <li>
                                    <a [routerLink]="'category/' + parentCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: parentCategory.url_path }" (click)="onLinkClick()" [ngClass]="{
                              'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                              'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                            }" class="title dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                        {{ parentCategory.name }}
                                    </a>
                                </li>

                                @if (parentCategory.sub_categories.length) {
                                @for (list of parentCategory.sub_categories; track list.id) {
                                <li (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()">
                                    <a [routerLink]="'category/' + list.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: list.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                        {{ list.name }}
                                    </a>
                                </li>
                                }
                                }
                            </ul>
                            }
                        </div>
                        }
                    </li>
                    }
                </div>
            </ul>
        </nav>
        }

        <!-- ⚡ Operation Buttons -->
        <div class="operation-button-container">
            <!-- Search -->
            @if (headerData.searchIcon.isVisibleOnDesktop && isDesktop()) {
            <a class="button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" (click)="toggleSearchDropDown()">
                <img [src]="headerData.searchIcon.searchIconSrc" />
            </a>
            } @else {
            @if (headerData.searchIconMobile.isVisibleOnMobile && isMobile()) {
            <a class="button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" (click)="toggleSearchDropDown()">
                <img [src]="headerData.searchIcon.searchIconSrc" />
            </a>
            }
            }

            <!-- Account -->
            @if (headerData.accountIcon.isVisibleOnMobile && isMobile()) {
            <a (click)="isHamburgerMenu = false" [target]="headerData.accountIcon.target" class="button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                <img [src]="headerData.accountIcon.accountIconSrc" />
            </a>
            } @else {
            @if (headerData.accountIcon.isVisibleOnDesktop && isDesktop()) {
            <a [target]="headerData.accountIcon.target" class="button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                <img [src]="headerData.accountIcon.accountIconSrc" />
            </a>
            }
            }

            <!-- Cart -->
            @if (headerData.cartIcon.isVisibleOnMobile && isMobile()) {
            <a (click)="isHamburgerMenu = false" [target]="headerData.cartIcon.target" class="button cart-btn dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                <img [src]="headerData.cartIcon.cartIconSrc" />
                <span class="cart-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                    {{ cart.cart_items.length }}
                </span>
            </a>
            } @else {
            @if (headerData.cartIcon.isVisibleOnDesktop && isDesktop()) {
            <a [target]="headerData.cartIcon.target" class="button cart-btn dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                <img [src]="headerData.cartIcon.cartIconSrc" />
                <span class="cart-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                    {{ cart.cart_items.length }}
                </span>
            </a>
            }
            }
        </div>

        <!-- 📱 Mobile Hamburger Menu -->
        @if (isHamburgerMenu && isMobile() && headerData.menuListVisibleOnMobile) {
        <div appClickOutside #changeHeaderMobileElement class="hamburger-menu-container" (click)="toggleHamburgerMenu()">
            <div class="hamburger-menu mobile-category-panel" (click)="$event.stopPropagation()">
                <static-menu-collapse [headerData]="headerData" (hideMenu$)="toggleHamburgerMenu()" />
                <webstore-dynamic-menu-collapse *ngIf="
              (dynamicHeaderInline() && layoutType() === 'inlineLayout1') ||
              (dynamicHeaderHover() && layoutType() === 'hoverLayout1')
            " #dynamicCategoryHeaderMobile [categories]="category || []" [menuCollapseIcon]="headerData.menuCollapseIcon" (hideMenu$)="toggleHamburgerMenu()" />
            </div>
        </div>
        }
    </div>
</section>